import 'angular:locale/data:en';
import 'zone.js';
import './src/polyfills.ts';(globalThis.$localize ??= {}).locale = "en";
